import front_rulesManager from "../modules/front/rulesManager";
import front_publisher from "../modules/front/publisher";
import front_adHocMessageComposer from "../modules/front/adHocMessageComposer";


export default function (html, target) {
	switch (target) {
		case 'front_rulesManager':
			front_rulesManager(html)
			break

		case 'front_publisher':
			front_publisher(html)
			break

		case 'front_adHocMessageComposer':
			front_adHocMessageComposer(html)
			break

		default:
			console.error('Module scope cannot be loaded: ' + target)
	}
}
